import BloquearAgenciaPage from "./BloquearAgenciaPage";

export {BloquearAgenciaPage}
export default BloquearAgenciaPage
